import { render, staticRenderFns } from "./FattorinoStatsList.vue?vue&type=template&id=fa7b8554&"
import script from "./FattorinoStatsList.vue?vue&type=script&lang=ts&"
export * from "./FattorinoStatsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports